// flow weak

  import React, { Component }     from 'react';
  import PropTypes                    from 'prop-types';
  import AnimatedView                 from '../../../components';
  import styles                       from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                                   from '../../../services/fetchTools';
  import { Spinner }                  from 'react-activity';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  
  
  class BulkPauseSubscription extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = { 
        venues:[],
        game_types:[],
        subscriptions:[],
        loading: false,
        venue:'',
        game_type:'',
        count:0,
        start_date:moment(),
        end_date:moment(),
        loading:true,
        data:[],
        filtered_data:[],
        selected_subs:[]
      };
      this.handleVenueChange = this.handleVenueChange.bind(this)
      this.handleGameChange = this.handleGameChange.bind(this)
      this.handleDateChange = this.handleDateChange.bind(this)
      this.handleStartDate = this.handleStartDate.bind(this);
      this.handleEndDate = this.handleEndDate.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this)
      this.handleSearch = this.handleSearch.bind(this);
    }
  
    componentDidMount() {
        this.getDetails();
    }  

    getDetails() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({ venues: data.venues, game_types: data.venues[0].game_types});
           // alert("fix");
           this.getPauseDetail();
       }).catch(error => error);
    }

    getPauseDetail(){
      let venue = this.state.venue;
      // let game_type = this.state.game_type;
      if(!venue){venue=this.state.venues[0].id}
      // if(!game_type){game_type=this.state.game_types[0].pk}
      var q_params = new URLSearchParams();
      q_params.append("venue", venue);
      // q_params.append("game_type", game_type);
      // console.log(q_params);
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_bulk_pause/?${q_params.toString()}`;
     const options = {...defaultOptions};
     // console.log(options);
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
          this.setState({ count: data.count, subscriptions: data.details, data:data.subscriptions, filtered_data:data.subscriptions,loading:false});
          // alert(`There are ${data.count} Subscription which can be paused`)
        })
       .catch(error => console.log(error));
      }

    postBulkPause(venue,game_type,count,subscriptions,start_date,end_date,selected_subs,props) {
      if(!venue){venue=this.state.venues[0].id}
      var date = moment(start_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
      var ending_date = moment(end_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
      // if(!game_type){game_type=this.state.game_types[0].pk}

      if(!venue){
        alert('Please Enter Venue')
      }
      // else if(!game_type){
      //   alert('Please Enter Game Type')
      // }
      else if(!count){
        alert('No Subscription Found')
      }
      else{
        var msg = `If not seleted any specific then all subscription will get paused. Are you Sure ?`;
        var result = confirm(msg);
        if(result){
          const url = `${getLocationOrigin()}/eagleeye/bulk_pause_subscription/`;
          const options = {...defaultOptions};
          options['method'] = 'post';
          options['headers'] = {'content-type': 'application/json'}
          options['body'] = JSON.stringify({
                                            'subscriptions':subscriptions,
                                            'selected_subs':selected_subs,
                                            'pause_end_date':ending_date,
                                            'starting_pause_date':date
                                          });
          console.log('Going to fetch');
          return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then(response=>{  
              console.log('response',response)
              alert(response.message)
              this.setState({loading:false,selected_subs:[]})
              if(response.success){
                this.getPauseDetail()
              }
              
            })
            .catch(error => {
              this.setState({loading:false,selected_subs:[]})
              console.log(error);
              alert(error.message);
            });
          }
        }
      }

    handleVenueChange(event) {
        const value = event.target.value
        const venue = this.state.venues.find(ven=> ven.id==value)
        let game_types = []
        let game_type = ''
        if(venue){
          game_types = venue.game_types
          game_type = game_types[0].pk
        }
        this.setState({venue: value,game_types:game_types,game_type:game_type,loading:true},()=>this.getPauseDetail());
    }

    handleGameChange(event) {
      const value = event.target.value
      this.setState({game_type:value},()=>this.getPauseDetail())
    }

    handleDateChange(event) {
      let value = event.target.value;
      this.setState({start_date:value})
    }

    handleSubmit(event) {
      console.log('handle')
      event.preventDefault();
      console.log('Submit');
      this.setState({loading:true})
      this.postBulkPause(this.state.venue,this.state.game_type,this.state.count,this.state.subscriptions,this.state.start_date,this.state.end_date,this.state.selected_subs,this.props)
    }

    handleStartDate(date){
      this.setState({start_date:date })
    }

    handleEndDate(date){
      this.setState({end_date:date })
    }

    handleCheckbox(event,sub) {
      const new_value =  Object.assign([], this.state.selected_subs);
      const subs = [...this.state.selected_subs];
      if(event.target.checked) {
        subs.push(sub)
      } else {
          const index = subs.findIndex((ch) => ch === sub);
          subs.splice(index, 1);
      }
      this.setState({selected_subs:subs});
    }

    handleSearch(event) {
      const search = event.target.value.toLowerCase()
      var search_list = []

      if(search == ''){
        search_list = this.state.data 
      }
      else{
        search_list = this.state.data.filter(item=> (
          item.customer.toLowerCase().indexOf(search) !== -1
          ))
      }
      this.setState({filtered_data:search_list,search:search})
    }
  
    render() {
      console.log('here is the data',this.state)
      const header = [' ','Customer','Package','Start Date','End Date']
      return(
        <div style={styles.container}> 

          <div className="row col-md-9 table-bordered" style={styles.table}>
            <div style={styles.main_header} className="col-md-12">
              <h3 style={{textAlign:'center'}}> Bulk Pause Subscription</h3>
            </div>
              <form  className="validated-form form-horizontal">

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Venue
                  </div>
                 <select name="city" className="col-md-6" style={styles.item_body} 
                   onChange={this.handleVenueChange} value={this.state.venue}>
                    {
                       this.state.venues && this.state.venues.length > 0 && this.state.venues.map((venue,index)=>(
                         <option key={venue.id} value={venue.id}>{venue.name}</option>
                        ))
                     }
                 </select>
                </div>

                {/*<div style={styles.items} className="col-md-12">
                                  <div style={styles.item_header} className="col-md-6">
                                    Game Type
                                  </div>
                                 <select name="city" className="col-md-6" style={styles.item_body} 
                                   onChange={this.handleGameChange} value={this.state.game_type}>
                                    {
                                       this.state.game_types && this.state.game_types.length > 0 && this.state.game_types.map((game_type,index)=>(
                                         <option key={game_type.pk} value={game_type.pk}>{`${game_type.game} ${game_type.name}`}</option>
                                        ))
                                     }
                                 </select>
                                </div>*/}

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Start Date
                  </div>
                  <DatePicker selected={this.state.start_date} onChange={this.handleStartDate} />
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    End Date
                  </div>
                  <DatePicker selected={this.state.end_date} onChange={this.handleEndDate} />
                </div>

                <div style={styles.message} className="col-md-12">
                  There are {this.state.count} Subscription which can be paused
                </div>

                {
                  this.state.data && this.state.data.length > 0 &&
                  <div className='col-md-12'>
                    <div className='badge badge-success' style={{background:'rgb(122, 101, 149)',color:'white',padding:'0.8% 1.2%',margin:'1% 0%',display:'flex',flexDirection:'row',float:'right',fontSize:'100%'}}>
                      <div style={{alignSelf:'center',fontWeight:'bold'}}>Search - </div> 
                      <input name='search' value={this.state.value} onChange={this.handleSearch} style={{color:'black',fontWeight:'500',margin:'0% 1%',width:'72%'}}/> 
                    </div>
                  <div className='col-md-12 table_container1' style={styles.table}>
                    <div className="heading heading2 left" style={styles.header}>List Of Subscriptions</div> 
                    <table className="table_plain">
                      <tr> 
                        { 
                          header.map((head)=>
                            <th style={{paddingRight:'1%'}}>{head}</th>
                            )
                         }
                      </tr>
                      
                        { this.state.filtered_data.length > 0 &&
                            this.state.filtered_data.map((subscription,index)=>
                            <tr>
                            <td style={{paddingRight:'1%'}}>
                              <input type="checkbox"
                                  checked={this.state.selected_subs.length > 0 ? this.state.selected_subs.find((ch) => ch === subscription.id):false}
                                  onChange={(e) => this.handleCheckbox(e, subscription.id)}
                              />
                            </td>
                            <td style={{paddingRight:'1%',paddingLeft:'1%'}}>{subscription.customer}</td>
                            <td style={{paddingRight:'1%'}}>{subscription.package}</td>
                            <td style={{paddingRight:'1%'}}>{subscription.start_date} </td>
                            <td style={{paddingRight:'1%'}}>{subscription.end_date}</td>
                            </tr>
                              )
                        }
                    </table>
                    { this.state.filtered_data.length == 0 &&
                      <div style={styles.message}>No Data Available</div> 
                    }
                  </div>
                </div>
                }

                { this.state.loading &&
                  <div style={{height:500}}>
                    <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
                  </div>
                }

                <div style={{display:'flex', flexDirection:'row', padding:'1%', marginLeft:'10px'}}>
                  <div style={styles.button_submit} className="col-md-12">
                    <input className="btn btn-lg" type="submit" value="Pause All" onClick={this.handleSubmit} style={{backgroundColor:'#302C35',
                      color:'#ffffff'}}/>
                  </div>
                </div>
                
              </form>
        
          </div>
        </div>
      );
    }
  }
  
  export default BulkPauseSubscription;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/bulkPauseSubscription/BulkPauseSubscription.js